import React, { useContext, useEffect } from 'react';

import Markup from '../../../../markup';
import BuilderContext from '../../../../builder/hooks/context';
import SurfaceNotice from "./SurfaceNotice";
import { trackBeforeUnload, trackSubStage } from '../../../../utils/Analytics';

function DesignSurface() {
    const {builder} = useContext(BuilderContext);


  useEffect(() => {
    trackSubStage('Design', 'Surface');
    trackBeforeUnload('Surface');
  }, []);

    return (
        <>
            <Markup.Screen.Design.Container checkCount={builder?.modelData?.surffaceList.length}>
                {builder?.modelData?.surffaceList?.map(item => <Markup.Screen.Design.ItemSurface
                    key={item.id}
                    active={builder.modelData.surfface === item.id}
                    onClick={() => builder.modelData.setSurfface(item.id)}
                    preview={item.surface_preview}
                    children={<SurfaceNotice text={item.surface_title} switch={item.surface_true} textContent={item.surface_text}/>}
                    themeColor={builder.membersData.colorTheme}
                />)}
            </Markup.Screen.Design.Container>
        </>
    );
}

export default React.memo(DesignSurface);